import CrudActionSetBase from './CrudActionSetBase'

export class ProgrammeActionSet extends CrudActionSetBase('programme'){}
export default new ProgrammeActionSet()